import Modal from "../Modal";
import Button from "@components/base/button";
import { handlePatch, updateLocalStorageOnboardingStatus } from "./utils";
import trackingEventDictionary from "@core/dictionary/tracking-event";

const Supademo = ({ comingFrom = null, onboardingInitiator, type, url, onboardingData, currOnboardingObj, handleSetCurrOnboarding, closeModal = () => null, modalHeading, description, checkPendoEventForCompanyRedirection }) => {
  const onboardingKeys = Object.keys(onboardingData?.onboarding_details || {});
  const currentIndex = onboardingKeys.indexOf(currOnboardingObj);
  const isLastVideo = currentIndex === onboardingKeys.length - 1;
  const handleNextVideo = () => {
    if (handleSetCurrOnboarding) {
      const nextKey = onboardingKeys[currentIndex + 1];
      const currentKey = onboardingKeys[currentIndex];
      updateLocalStorageOnboardingStatus("onboarding", currentKey);
      const data = onboardingData?.onboarding_details;
      if (!data[currentKey].isViewed) {
        handlePatch("onboarding", currentKey);
      }
      handleSetCurrOnboarding(nextKey, onboardingInitiator);
      if (checkPendoEventForCompanyRedirection) checkPendoEventForCompanyRedirection(trackingEventDictionary.onboardingGoToNextVideo);
      if (isLastVideo) {
        if (checkPendoEventForCompanyRedirection) {
          checkPendoEventForCompanyRedirection(trackingEventDictionary.onboardingContinueToPlatform);
        }
        closeModal();
      }
    }
  };
  if (type === "modal") {
    return (
      <Modal isOpen={true} size="full" onClose={closeModal}>
        <Modal.Header>
          <div className="tw-flex tw-items-center tw-justify-between">
            <div className="tw-text-xl tw-font-semibold tw-text-gray-900">{modalHeading}</div>
            <span onClick={closeModal} className="tw-p-1 tw-cursor-pointer tw-rounded-full tw-hover:bg-gray-100 tw-transition-colors" aria-label="Close modal">
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#101828">
                <path d="M256-213.85 213.85-256l224-224-224-224L256-746.15l224 224 224-224L746.15-704l-224 224 224 224L704-213.85l-224-224-224 224Z" />
              </svg>
            </span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="tw-flex tw-flex-col tw-gap-2 tw-py-2 tw-h-full">
            <div className="tw-text-base tw-font-medium">{description}</div>
            <embed src={url} className="tw-w-full tw-h-full" />
          </div>
        </Modal.Body>
        <Modal.Footer>
          {comingFrom === "shipments" && (
            <div>
              <Button variant="secondaryWithIcon" size="small" className="tw-ml-1 tw-mr-2 tw-font-medium tw-text-sm tw-flex tw-items-center disabled:tw-cursor-not-allowed" onClick={handleNextVideo} id="shipment-default-download-excel-button">
                <span className="material-symbols-outlined">{isLastVideo ? "" : "arrow_forward"}</span>
                <span className="ml-1">{isLastVideo ? "Continue To Platform" : "Go to Next Video"}</span>
              </Button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    );
  }

  return <embed src={url} className="tw-w-full tw-h-full" />;
};

export default Supademo;
